import { render, staticRenderFns } from "./WarmWhite.vue?vue&type=template&id=f2cfed74&"
import script from "./WarmWhite.vue?vue&type=script&lang=js&"
export * from "./WarmWhite.vue?vue&type=script&lang=js&"
import style0 from "./WarmWhite.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports